import { render } from "./tournament_login_form.vue?vue&type=template&id=18266e66"
import script from "./tournament_login_form.vue?vue&type=script&lang=js"
export * from "./tournament_login_form.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__